import { createTheme, ThemeOptions } from '@mui/material/styles';

const theme: ThemeOptions = createTheme({
  palette: {
    primary: {
      main: '#009FE3',
    },
    secondary: {
      main: '#f50057',
    },
  },
  components: {
    MuiInputBase: {
      styleOverrides: {
        root: {
          '&. Mui-disabled': {
            color: 'black',
            WebkitTextFillColor: '#000000b3 !important',
          },
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        root: {
          '& .Mui-disabled': {
            color: 'black',
            WebkitTextFillColor: '#000000b3 !important',
          },
        },
      },
    },
  },
});

export default theme;
